import { PLAQUE_FIELDS, plaqueVin, vehicleToPlaque } from "../../utils/vehiclePlaque";
import "./vehiclePlaque.css";
import PlaqueArtwork from "./PlaqueArtwork";

export default function VehiclePlaquePreview({ car, config, artworkUrl, artworkMetadata, vin = "", isOwner = false }) {
  const { values } = vehicleToPlaque(car, config);
  const visible = new Set(config.visibleFields);
  const shown = (key) => visible.has(key) ? values[key] : "";
  const displayedVin = plaqueVin(vin, config.vinMode, isOwner);
  const rows = PLAQUE_FIELDS.filter(([key]) => !["make", "model", "generation", "trim", "buildId", "ownerName", "customLine"].includes(key) && shown(key));
  return <article className={`vehicle-plaque ${config.appearance?.density === "compact" ? "compact" : ""}`} aria-label="Live vehicle plaque preview">
    <header>
      {shown("make") && <p className="plaque-make">{shown("make")}</p>}
      {shown("model") && <h2>{shown("model")}</h2>}
      {(shown("generation") || shown("trim")) && <p className="plaque-generation">{[shown("generation"), shown("trim")].filter(Boolean).join(" · ")}</p>}
    </header>
    <div className="plaque-silhouette">
      {artworkUrl ? <PlaqueArtwork key={artworkUrl} artworkUrl={artworkUrl} artworkMetadata={artworkMetadata} /> :
        <p>Vehicle artwork is not available yet.</p>}
    </div>
    {rows.length > 0 && <dl className="plaque-specifications">{rows.map(([key, label]) => <div key={key}>
      <dt>{label}</dt><dd>{shown(key)}</dd>
    </div>)}</dl>}
    {(shown("buildId") || displayedVin || shown("ownerName") || shown("customLine")) && <footer aria-label="Plaque identity">
      <div className="plaque-identifiers">
        {shown("buildId") && <div><span>Build ID</span><strong>{shown("buildId")}</strong></div>}
        {displayedVin && <div><span>{config.vinMode === "last6" ? "VIN · Last 6" : "VIN"}</span><strong>{displayedVin}</strong></div>}
      </div>
      {shown("ownerName") && <p className="plaque-owner"><span>Owner name</span> {shown("ownerName")}</p>}
      {shown("customLine") && <p className="plaque-custom-line">{shown("customLine")}</p>}
    </footer>}
  </article>;
}
